<button
  type="button"
  [class.invisible]="!showSecondaryToolbarButton"
  id="secondaryToolbarToggle"
  class="toolbarButton"
  title="Tools"
  data-l10n-id="tools"
>
  <svg style="width:27px;height:27px" viewBox="0 0 24 24" onclick="event.preventDefault(); return false;">
    <path fill="currentColor" d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
  </svg>
  <span data-l10n-id="tools_label">Tools</span>
</button>
